import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";

export const MaritalStatusInfoModal = () => {
  const { dismiss } = useModal();

  const props: OverlayProps = {
    title: i18n.t(Translations.MaritalStatusRouteInfoModalTitle),
    subtitle: i18n.t(Translations.MaritalStatusRouteInfoModalSubtitle),
    cta: {
      primary: {
        title: i18n.t(Translations.MaritalStatusRouteInfoModalPrimaryCTA),
        onClick: dismiss,
      },
    },
  };

  return <Overlay {...props} />;
};
